import {createFileRoute} from '@tanstack/react-router'
import {firstLevelIndexRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg-collection/browse/$primarySorting/')({
    ...firstLevelIndexRoute("/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName"),
});
